import type { ReactElement } from 'react'

import type { TypeSectionFaqEntry } from '@contentful-types/section-faq'

import { PageSection } from '@components/page-core/section/page-section'
import { renderRichText } from '@components/renderer/rich-text'
import type { EntryContentProps } from '@components/renderer/types'
import { TabSection } from '@components/section/tabs/tab-section'
import { Accordion } from '@components/ui-core/accordion/accordion'

import { FaqSchemaMarkup } from './faq-schema-markup'

export function FaqContent({ data }: EntryContentProps<TypeSectionFaqEntry>): ReactElement {
  const {
    fields: { content },
  } = data

  const faqs = content.filter(item => item !== undefined)

  if (faqs.length === 0) {
    return <></>
  }

  const formattedFaqs = faqs.map(faq => ({
    id: faq?.sys?.id,
    trigger: faq?.fields?.question,
    content: renderRichText(faq?.fields?.answer),
  }))

  return (
    <>
      <FaqSchemaMarkup data={faqs} />
      <Accordion data={formattedFaqs} allowMultipleExpanded={false} />
    </>
  )
}

export function SectionFaq({ data }: EntryContentProps<TypeSectionFaqEntry>): ReactElement {
  const {
    sys,
    fields: { internalName, background, heading, alignment },
  } = data

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      background={background}
      alignment={alignment}
      heading={heading}
    >
      <FaqContent data={data} />
    </PageSection>
  )
}

export function FaqContentForTabs({ data }: EntryContentProps<TypeSectionFaqEntry>): ReactElement {
  const {
    fields: { background, heading, alignment },
  } = data

  return (
    <TabSection background={background} alignment={alignment} heading={heading}>
      <FaqContent data={data} />
    </TabSection>
  )
}
